import { PageRoutes } from "./historyGaming";

export const FOOTER_NAVIGATION = [
  {
    id: "home",
    path: PageRoutes.HomePage,
    title: "Home",
    icon: "icon-linear-home",
    iconActive: "icon-bold-home",
  },
  {
    id: "rank",
    title: "Rank",
    path: PageRoutes.Rank,
    icon: "icon-linear-ranking",
    iconActive: "icon-bold-ranking",
  },
  {
    id: "icon-button",
    iconActive: "icon-bold-arrow-down-3",
  },
  {
    id: "friends",
    path: PageRoutes.Friends,
    title: "Friends",
    icon: "icon-linear-profile-2user",
    iconActive: "icon-bold-profile-2user",
  },
  {
    id: "shop",
    path: PageRoutes.Shop,
    title: "Shop",
    icon: "icon-shopping-bag1",
    iconActive: "icon-bold-shopping-bag",
  },
];

export const FOOTER_NAVIGATION_VODACOM = [
  {
    id: "home",
    path: PageRoutes.HomePage,
    title: "common_Feed",
    icon: "icon-game-bold",
  },
  {
    id: "video",
    path: PageRoutes.VideosVodacom,
    title: "common_Media",
    icon: "icon-bold-media",
  },
  {
    id: "shop",
    path: PageRoutes.Shop,
    title: "common_Store",
    icon: "icon-shop",
  },
  {
    id: "rank",
    title: "eSports",
    path: PageRoutes.Esports,
    icon: "icon-esports",
  },
];

export const FOOTER_NAVIGATION_WIDTH = 375;
export const FOOTER_NAVIGATION_HEIGHT = 72;
